export default __webpack_public_path__ + "static/springandsummer (13)-22f67356563a8188a18daed85aa778dd.jpeg";